import { createCalendar } from "@internationalized/date";
import { useCalendar } from "@react-aria/calendar";
import { useLocale } from "@react-aria/i18n";
import { type CalendarStateOptions, useCalendarState } from "@react-stately/calendar";
import { type FC, useRef } from "react";
import { type DateValue } from "react-aria";

import { CalendarGrid } from "./CalendarGrid";
import { CalendarHeader } from "./CalendarHeader";

export type CalendarProps = Omit<CalendarStateOptions<DateValue>, "locale" | "createCalendar"> & {
	visibleDurationMonths?: 1 | 2;
};

export const Calendar: FC<CalendarProps> = ({ visibleDurationMonths = 1, ...props }) => {
	const { locale } = useLocale();
	const state = useCalendarState({
		...props,
		visibleDuration: { months: visibleDurationMonths },
		locale,
		createCalendar,
	});

	const ref = useRef<HTMLDivElement>(null);
	const { calendarProps, prevButtonProps, nextButtonProps } = useCalendar(props, state);

	return (
		<div {...calendarProps} ref={ref} className="inline-block text-primary">
			<CalendarHeader
				state={state}
				calendarProps={calendarProps}
				prevButtonProps={prevButtonProps}
				nextButtonProps={nextButtonProps}
			/>
			<div className="flex items-start gap-8">
				<CalendarGrid state={state} />
				{visibleDurationMonths > 1 && <CalendarGrid state={state} offset={{ months: 1 }} />}
			</div>
		</div>
	);
};
